import React from 'react';
import { Form, Checkbox, Button, Typography } from 'antd';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

const { Title } = Typography;
const samplePDF ="https://firebasestorage.googleapis.com/v0/b/operataxis.firebasestorage.app/o/DriverRegistration%2FOpera%20Taxis%20Driver%20Onboarding%20Training.pdf?alt=media&token=6ce1fe2a-c936-4db2-bd0c-70d45f74546e"
const Step10 = ({ form, next, prev }) => {
  const handleSubmit = () => {
    form
      .validateFields()
      .then(values => {
        next();
      })
      .catch(errorInfo => {
        console.log('Validation Failed:', errorInfo);
      });
  };

  return (
    <Form form={form} layout="vertical" style={{ maxWidth: 800, margin: '0 auto' }}>
      <Title level={2}>Driver Training</Title>
      <div style={{ height: "500px", border: "1px solid #ccc", marginBottom: "20px" }}>
      <iframe
          src={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(samplePDF)}`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="PDF Viewer"
        />
      </div>

      <Form.Item
        name="driverTraining"
        valuePropName="checked"
        rules={[{ required: true, message: 'Please confirm you have read the driver training.' }]}
      >
        <Checkbox  onChange={(e) => {
      form.setFieldsValue({
        driverTraining: e.target.checked ? "agree" : undefined,
      });
    }}>I have read the driver training manual and will act accordingly.</Checkbox>
      </Form.Item>

      <Form.Item style={{ textAlign: 'center' }}>
        <Button onClick={prev} style={{ marginRight: 8 }}>
          Back
        </Button>
        <Button type="primary" onClick={handleSubmit}>
          Next
        </Button>
      </Form.Item>
    </Form>
  );
};

export default Step10;
